import { makeStyles, Theme, createStyles } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom'
import { SharedDataProvider } from '../../../../../shared/providers/SharedDataProvider'
import { Machine } from '../../../../models/Machine'

interface MachineSearchResultProps {
  machine: Machine
}

export const MachineSearchResult = ({ machine }: MachineSearchResultProps) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      searchResult: {
        backgroundColor: 'ffffff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        borderRadius: '5px',
        width: 240,
        margin: 5,
        overflow: 'hidden',
        boxShadow:
          '0 5px 5px 0 rgba(0, 0, 0, 0.25), 0 5px 5px 0 rgba(0, 0, 0, 0.025)',
      },
      searchResultTop: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      machinePicture: {
        objectFit: 'contain',
        objectPosition: 'center',
        width: '100px',
        borderRadius: '50%',
      },
      companyLogo: {
        objectFit: 'contain',
        objectPosition: 'center',
        height: '80px',
        width: '180px',
      },
      searchResultBottom: {
        display: 'flex',
        margin: 5,
        flexDirection: 'column',
        position: 'relative',
      },
      searchResultMainData: {
        color: '#212121',
        fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        fontSize: 16,
        textAlign: 'left',
      },
      searchResultOtherData: {
        color: '#212121',
        fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        fontSize: 12,
        textAlign: 'left',
      },
    })
  )
  const classes = useStyles()

  const sharedDataProvider = new SharedDataProvider()

  return (
    <Link
      key={machine._id}
      to={`/machine/${machine._id}`}
      className={classes.searchResult}
      style={{ textDecoration: 'none' }}
    >
      <div className={classes.searchResultTop}>
        <img
          className={classes.machinePicture}
          key={machine._id}
          src={
            sharedDataProvider.host +
            '/machines/getMachinePicture?id=' +
            machine._id +
            '&' +
            new Date()
          }
        ></img>
      </div>
      <div className={classes.searchResultBottom}>
        <div className={classes.searchResultMainData}>
          {machine.machineNumber}
        </div>
      </div>
    </Link>
  )
}
